module.exports = __webpack_public_path__ + "static/media/fa-IR.751550d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/fa-IR.png
// module id = 944
// module chunks = 0